module.exports = __webpack_public_path__ + "img/tutor.8afad02c.png";